module.exports = __webpack_public_path__ + "static/media/forgetPassword.0f0d2476.png";